import React, { useEffect, useState } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Table,
  Row,
  Col,
  Button,
} from "reactstrap";
import api from "../../utils/axiosApi";
import moment from "moment";

function VentasCalendarios() {
  const PAGE_SIZE = 20;
  const token =
    sessionStorage.getItem("jwtuser") || localStorage.getItem("jwtuser");
  const [ventas, setVentas] = useState([]);
  const [loading, setLoading] = useState(true);

  const [pages, setPages] = useState({
    total: 0,
    actualPage: 0,
    maxPages: 1,
  });
  useEffect(() => {
    const fetchVentas = async () => {
      try {
        const response = await api.get(
          `/ModelsCalendar/bought-calendars/?page[number]=0&page[size]=${PAGE_SIZE}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        debugger;
        const total = response.data.meta.page.total;
        const cantPag = Math.ceil(total / PAGE_SIZE);
        setVentas(response.data.data || []);
        setPages((prev) => ({ ...prev, maxPages: cantPag, total }));
      } catch (error) {
        console.error("Error cargando ventas:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchVentas();
  }, []);

  const nextPage = async () => {
    const next = pages.actualPage + 1;
    if (next >= pages.maxPages) return;

    const response = await api.get(
      `/ModelsCalendar/bought-calendars/?page[number]=${next}&page[size]=${PAGE_SIZE}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const total = response.data.meta.page.total;
    const cantPag = Math.ceil(total / PAGE_SIZE);

    setPages((prev) => ({ ...prev, actualPage: next, maxPages: cantPag, total  }));
  };

  const PrevPage = async () => {
    const prevPage = pages.actualPage - 1;
    if (prevPage < 0) return;

    const response = await api.get(
      `/ModelsCalendar/bought-calendars/?page[number]=${prevPage}&page[size]=${PAGE_SIZE}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const total = response.data.meta.page.total;
    const cantPag = Math.ceil(total / PAGE_SIZE);
    setVentas(response.data.data || []);
    setPages((prev) => ({ ...prev, actualPage: prevPage, maxPages: cantPag, total }));
  };
  return (
    <div className="content">
      <Row>
        <Col md="12">
          <Card>
            <CardHeader>
              <Row>
                <Col>
                  <CardTitle tag="h4">Calendarios Vendidos</CardTitle>
                </Col>
                <Col className="pr-md-1" md="4">
                  <Button disabled={pages.actualPage === 0} onClick={PrevPage}>
                    Anterior
                  </Button>
                  <Button disabled>
                    {pages.actualPage + 1} de {pages.maxPages}
                  </Button>
                  <Button
                    disabled={pages.actualPage >= pages.maxPages - 1}
                    onClick={nextPage}
                  >
                    Siguiente
                  </Button>
                </Col>
              </Row>
            </CardHeader>
            <CardBody>
              {loading ? (
                <p>Cargando...</p>
              ) : (
                <Table className="tablesorter" responsive>
                  <thead className="text-primary">
                    <tr>
                      <th>Nombre</th>
                      <th>Agencia</th>
                      <th>Fecha Compra</th>
                      <th>Estado</th>
                    </tr>
                  </thead>
                  <tbody>
                    {ventas.map((v, i) => (
                      <tr key={`venta-${i}`}>
                        <td>{v.cloned_calendar?.name || "Sin nombre"}</td>
                        <td>{v.agency?.nameAgency || "Sin agencia"}</td>
                        <td>{moment(v.createdAt).format("YYYY-MM-DD")}</td>
                        <td>{v.status}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default VentasCalendarios;
